<template>
  <div>
    <p>
      Sběr a vyhodnocení kvality koupacích vod probíhá během koupací sezóny
      (zpravidla od května do září) následujícím způsobem:
    </p>

    <h3>Vody ke koupání</h3>

    <p>
      Kontroly jakosti koupací vody jsou prováděny krajskými hygienickými
      stanicemi (KHS) nebo provozovateli koupališť minimálně jedenkrát měsíčně
      (u koupacích vod, u kterých lze během koupací sezóny odůvodněně
      předpokládat rozmnožení sinic, může být četnost kontroly zvýšena). V rámci
      těchto kontrol jsou oprávněnými laboratořemi odebírány vzorky vody k
      analýze. Vzorky odebrané obvykle v pondělí jsou analyzovány v laboratořích
      a výsledky jsou vkládány do centrálního informačního systému kvality
      pitných a koupacích vod PiVo do čtvrtečního odpoledne. Během čtvrtečního
      odpoledne jsou výsledky verifikovány pracovníky KHS včetně vyhodnocení
      kvality vody dle platných předpisů. Během pátku jsou údaje dostupné na
      tomto serveru, pracovníci Státního zdravotního ústavu v Praze (SZÚ) ve
      spolupráci s Českou agenturou životního prostředí (Cenia) připraví údaje
      pro prezentaci na stránkách Národního geoportálu INSPIRE a na evropském
      portálu kvality koupacích vod.
    </p>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$emit("caption", "O koupacích vodách");
  }
};
</script>

<style scoped>
.side {
  margin: 5px;
  padding: 2.5em;
  font-family: Arial, Helvetica, sans-serif;
  padding-top: 0;
  height: 91%;
  overflow: auto;
}
</style>
